// Warehouse Scanner inside the dashboard: the same app as scanner.jumiadash.store
// (packing, order scan, Marjan preparation, find), behind the dashboard login and
// the "scanner" permission ticked per user in Admin → Users.
import ScannerApp from "../components/scanner/ScannerApp";

const ScannerPage = () => <ScannerApp />;

export default ScannerPage;
